import { render, staticRenderFns } from "./MobileApps.vue?vue&type=template&id=0f667b1c&scoped=true&"
import script from "./MobileApps.vue?vue&type=script&lang=js&"
export * from "./MobileApps.vue?vue&type=script&lang=js&"
import style0 from "./MobileApps.vue?vue&type=style&index=0&id=0f667b1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f667b1c",
  null
  
)

export default component.exports